
import React, { forwardRef, createContext, useContext, useState } from 'react';

import { IMETAMessageType } from '../config/imetahuman';
import { useAuthentication } from "../provider/Auth";

const MetaHumanContext = createContext();


export const MetaHumanComponent = forwardRef((props, ref) => {


    return (
        <div>
            <div id="player" ></div>
            <div id="overlay" className="Invisible">
                <div>
                    <div id="qualityStatus" className="greyStatus"></div>
                    <div id="overlayButton"></div>
                </div>
            </div>
        </div>
    );
});

export const MetaHumanProvider = ({ children }) => {

    const [isInitialized, setIsInitialized] = useState(false);
    const [isTalking, setIsTalking] = useState(false);
    const { getConfig } = useAuthentication();

    const actor = async (actor) => {
        const msg = { type: IMETAMessageType.UEActor, actor: actor };
        emitUIInteraction(msg);
    }

    const background = async (background) => {
        console.log("MT - BG", background);
        const msg = { type: IMETAMessageType.UEBackground, background: 'cfg', image: background };
        emitUIInteraction(msg);
    }

    const voice = async (voice) => { 
        console.log("MT - Voice", voice);
        const msg = { type: IMETAMessageType.UEVoice, voice: voice};
        emitUIInteraction(msg);
    }

    const setResolution = async(width,height) => {

        let descriptor = {
            Resolution: {
                Width: width,
                Height: height
            }
        }


        emitDescriptor(MessageType.Command, descriptor);
    }

    const toUE = async (message) => {
        emitUIInteraction(message);
    }



    let haveWebkitEvents = 'WebKitGamepadEvent' in window;
    let controllers = {};
    let rAF = window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.requestAnimationFrame;

    let qualityControlOwnershipCheckBox;
    let matchViewportResolution;

    let onDataChannelConnected;
    let responseEventListeners = new Map();
    let streamingDataListeners = new Map();

    let webRtcPlayerObj = null;
    let print_stats = false;
    let print_inputs = false;
    let connect_on_load = false;

    let is_reconnection = false;
    let ws;
    const WS_OPEN_STATE = 1;

    let afk = {
        enabled: false,   // Set to true to enable the AFK system.
        warnTimeout: 120,   // The time to elapse before warning the user they are inactive.
        closeTimeout: 10,   // The time after the warning when we disconnect the user.

        active: false,   // Whether the AFK system is currently looking for inactivity.
        overlay: undefined,   // The UI overlay warning the user that they are inactive.
        warnTimer: undefined,   // The timer which waits to show the inactivity warning overlay.
        countdown: 0,   // The inactivity warning overlay has a countdown to show time until disconnect.
        countdownTimer: undefined,   // The timer used to tick the seconds shown on the inactivity warning overlay.
    }




    // Must be kept in sync with PixelStreamingProtocol::EToUE4Msg C++ enum.
    const MessageType = {

        /**********************************************************************/

        /*
         * Control Messages. Range = 0..49.
         */
        IFrameRequest: 0,
        RequestQualityControl: 1,
        MaxFpsRequest: 2,
        AverageBitrateRequest: 3,
        StartStreaming: 4,
        StopStreaming: 5,
        LatencyTest: 6,
        RequestInitialSettings: 7,

        /**********************************************************************/

        /*
         * Input Messages. Range = 50..89.
         */

        // Generic Input Messages. Range = 50..59.
        UIInteraction: 50,
        Command: 51,

        // Keyboard Input Message. Range = 60..69.
        KeyDown: 60,
        KeyUp: 61,
        KeyPress: 62,

        // Mouse Input Messages. Range = 70..79.
        MouseEnter: 70,
        MouseLeave: 71,
        MouseDown: 72,
        MouseUp: 73,
        MouseMove: 74,
        MouseWheel: 75,

        // Touch Input Messages. Range = 80..89.
        TouchStart: 80,
        TouchEnd: 81,
        TouchMove: 82,

        // Gamepad Input Messages. Range = 90..99
        GamepadButtonPressed: 90,
        GamepadButtonReleased: 91,
        GamepadAnalog: 92

        /**************************************************************************/


    };


    // Must be kept in sync with PixelStreamingProtocol::EToPlayerMsg C++ enum.
    const ToClientMessageType = {
        QualityControlOwnership: 0,
        Response: 1,
        Command: 2,
        FreezeFrame: 3,
        UnfreezeFrame: 4,
        VideoEncoderAvgQP: 5,
        LatencyTest: 6,
        InitialSettings: 7
    };

    let VideoEncoderQP = "N/A";

    const initialize = () => {
        console.log("ON LOAD");
        window.__safeRtc = undefined;
        let playerDiv = document.getElementById('player');
        if (webRtcPlayerObj) {
            playerDiv.removeChild(webRtcPlayerObj.video);
            webRtcPlayerObj.close();
            webRtcPlayerObj = undefined;
        }



        if (!connect_on_load || is_reconnection) {
            connect();
        } else {
            connect();
        }
    }

    const smallVideoBox = (enabled) => {

        if (enabled === true)  {
             document.querySelector('#streamingVideo').classList.add('player-window');
             document.querySelector('#streamingVideo').classList.remove('player-full');
        }
        if (enabled !== true)  { 
            document.querySelector('#streamingVideo').classList.add('player-full');
            document.querySelector('#streamingVideo').classList.remove('player-window');
        }

    }

    const playVideoStream = () => {

        if (webRtcPlayerObj && webRtcPlayerObj.video) {

            webRtcPlayerObj.video.play().catch(function (onRejectedReason) {
                console.error(onRejectedReason);
                console.log("Browser does not support autoplaying video without interaction - to resolve this we are going to show the play button overlay.")

            });

            requestInitialSettings();
            requestQualityControl();
            //showFreezeFrameOverlay();
            //hideOverlay();
            setIsInitialized(true);
        } else {
            console.error("Could not player video stream because webRtcPlayerObj.video was not valid.")
        }
    }



    const requestInitialSettings = () => {
        sendInputData(new Uint8Array([MessageType.RequestInitialSettings]).buffer);
    }

    const requestQualityControl = () => {
        sendInputData(new Uint8Array([MessageType.RequestQualityControl]).buffer);
    }

    const emitUIInteraction = (descriptor) => {


        if (descriptor.hasOwnProperty('type') && descriptor.type === IMETAMessageType.UESpeak) {
            setIsTalking(true);
        }
        emitDescriptor(MessageType.UIInteraction, descriptor);
    }

    const addResponseEventListener = (name, listener) => {
        responseEventListeners.set(name, listener);
    }

    const removeResponseEventListener = (name) => {
        responseEventListeners.remove(name);
    }

    const addStreamingDataListeners = (name,listener) => {
        streamingDataListeners.set(name,listener);
    }

    const removeStreamingDataListeners = (name) => {
        streamingDataListeners.remove(name);
    }

    const emitDescriptor = (messageType, descriptor) => {
        // Convert the dscriptor object into a JSON string.
        let descriptorAsString = JSON.stringify(descriptor);

        // Add the UTF-16 JSON string to the array byte buffer, going two bytes at
        // a time.
        let data = new DataView(new ArrayBuffer(1 + 2 + 2 * descriptorAsString.length));
        let byteIdx = 0;
        data.setUint8(byteIdx, messageType);
        byteIdx++;
        data.setUint16(byteIdx, descriptorAsString.length, true);
        byteIdx += 2;
        for (let i = 0; i < descriptorAsString.length; i++) {
            data.setUint16(byteIdx, descriptorAsString.charCodeAt(i), true);
            byteIdx += 2;
        }
        sendInputData(data.buffer);
    }


    const resetAfkWarningTimer = () => {
        if (afk.active) {
            clearTimeout(afk.warnTimer);
            afk.warnTimer = setTimeout(function () {
                showAfkOverlay();
            }, afk.warnTimeout * 1000);
        }
    }

    const stopAfkWarningTimer = () => {
        afk.active = false;
    }

    const startAfkWarningTimer = () => {
        afk.active = afk.enabled;
        resetAfkWarningTimer();
    }


    const showAfkOverlay = () => {
        // Pause the timer while the user is looking at the inactivity warning overlay.
        stopAfkWarningTimer();

        // Show the inactivity warning overlay.
        afk.overlay = document.createElement('div');
        afk.overlay.id = 'afkOverlay';
        setOverlay('clickableState', afk.overlay, event => {
            // The user clicked so start the timer again and carry on.

            clearInterval(afk.countdownTimer);
            startAfkWarningTimer();
        });

        afk.countdown = afk.closeTimeout;


        afk.countdownTimer = setInterval(function () {
            afk.countdown--;
            if (afk.countdown === 0) {
                // The user failed to click so disconnect them.
                ws.close();
            } else {
                // Update the countdown message.
            }
        }, 1000);
    }

    const setOverlay = (htmlClass, htmlElement, onClickFunction) => {
        let videoPlayOverlay = document.getElementById('videoPlayOverlay');
        if (!videoPlayOverlay) {
            let playerDiv = document.getElementById('player');
            videoPlayOverlay = document.createElement('div');
            videoPlayOverlay.id = 'videoPlayOverlay';
            playerDiv.appendChild(videoPlayOverlay);
        }

        // Remove existing html child elements so we can add the new one
        while (videoPlayOverlay.lastChild) {
            videoPlayOverlay.removeChild(videoPlayOverlay.lastChild);
        }

        if (htmlElement)
            videoPlayOverlay.appendChild(htmlElement);

        if (onClickFunction) {
            videoPlayOverlay.addEventListener('click', function onOverlayClick(event) {
                onClickFunction(event);
                videoPlayOverlay.removeEventListener('click', onOverlayClick);
            });
        }

        // Remove existing html classes so we can set the new one
        let cl = videoPlayOverlay.classList;
        for (let i = cl.length - 1; i >= 0; i--) {
            cl.remove(cl[i]);
        }

        videoPlayOverlay.classList.add(htmlClass);
    }




    const setupWebRtcPlayer = (htmlElement, config) => {
        webRtcPlayerObj = new window.webRtcPlayer(config);
        window.__safeRtc = webRtcPlayerObj;
        htmlElement.appendChild(webRtcPlayerObj.video);


        webRtcPlayerObj.onWebRtcOffer = function (offer) {
            if (ws && ws.readyState === WS_OPEN_STATE) {
                let offerStr = JSON.stringify(offer);
                console.log(`-> SS: offer:\n${offerStr}`);
                ws.send(offerStr);
            }
        };

        webRtcPlayerObj.onWebRtcCandidate = function (candidate) {
            if (ws && ws.readyState === WS_OPEN_STATE) {
                console.log(`-> SS: iceCandidate\n${JSON.stringify(candidate, undefined, 4)}`);
                ws.send(JSON.stringify({
                    type: 'iceCandidate',
                    candidate: candidate
                }));
            }
        };


        webRtcPlayerObj.onVideoInitialised = function () {
            if (ws && ws.readyState === WS_OPEN_STATE) {
                playVideoStream();
            }
        };

        webRtcPlayerObj.onDataChannelConnected = function () {
            if (ws && ws.readyState === WS_OPEN_STATE) {
                console.log('WebRTC connected, waiting for video');
                if (webRtcPlayerObj.video && webRtcPlayerObj.video.srcObject && webRtcPlayerObj.onVideoInitialised) {
                    webRtcPlayerObj.onVideoInitialised();
                }
            }
        };


        webRtcPlayerObj.onDataChannelMessage = function (data) {
            let view = new Uint8Array(data);

            if (view[0] === ToClientMessageType.QualityControlOwnership) {
                let ownership = view[1] === 0 ? false : true;
                console.log("Received quality controller message, will control quality: " + ownership);
                // If we own the quality control, we can't relenquish it. We only loose
                // quality control when another peer asks for it
                /*
                if (qualityControlOwnershipCheckBox !== null) {
                    qualityControlOwnershipCheckBox.disabled = ownership;
                    qualityControlOwnershipCheckBox.checked = ownership;
                }
                */
            } else if (view[0] === ToClientMessageType.Response) {
                let response = new TextDecoder("utf-16").decode(data.slice(1));

                let jp = JSON.parse(response);
                if (jp.hasOwnProperty('type') && jp.type === IMETAMessageType.UEStopSpeak) {
                    setIsTalking(false);
                }

                
                for (let listener of responseEventListeners.values()) {
                    listener(response);
                }
            } else if (view[0] === ToClientMessageType.Command) {
                let commandAsString = new TextDecoder("utf-16").decode(data.slice(1));
                console.log(commandAsString);
                let command = JSON.parse(commandAsString);
                if (command.command === 'onScreenKeyboard') {
                    //showOnScreenKeyboard(command);
                }
            } else if (view[0] === ToClientMessageType.FreezeFrame) {
                // processFreezeFrameMessage(view);
                console.log("Process Freeze");
            } else if (view[0] === ToClientMessageType.UnfreezeFrame) {
                // invalidateFreezeFrameOverlay();
                console.log("Ivalidate Freeze");
            } else if (view[0] === ToClientMessageType.VideoEncoderAvgQP) {
                VideoEncoderQP = new TextDecoder("utf-16").decode(data.slice(1));
                //console.log(`received VideoEncoderAvgQP ${VideoEncoderQP}`);
            } else if (view[0] === ToClientMessageType.LatencyTest) {
                let latencyTimingsAsString = new TextDecoder("utf-16").decode(data.slice(1));
                console.log("Got latency timings from UE.")
                console.log(latencyTimingsAsString);
                let latencyTimingsFromUE = JSON.parse(latencyTimingsAsString);
                if (webRtcPlayerObj) {
                    webRtcPlayerObj.latencyTestTimings.SetUETimings(latencyTimingsFromUE);
                }
            } else if (view[0] === ToClientMessageType.InitialSettings) {
                let settingsString = new TextDecoder("utf-16").decode(data.slice(1));
                let settingsJSON = JSON.parse(settingsString);
                // reminder bitrates are sent in bps but displayed in kbps

                if (settingsJSON.Encoder) {
                    /*
                    document.getElementById('encoder-rate-control').value = settingsJSON.Encoder.RateControl;
                    document.getElementById('encoder-target-bitrate-text').value = settingsJSON.Encoder.TargetBitrate > 0 ? settingsJSON.Encoder.TargetBitrate / 1000 : settingsJSON.Encoder.TargetBitrate;
                    document.getElementById('encoder-max-bitrate-text').value = settingsJSON.Encoder.MaxBitrate > 0 ? settingsJSON.Encoder.MaxBitrate / 1000 : settingsJSON.Encoder.MaxBitrate;
                    document.getElementById('encoder-min-qp-text').value = settingsJSON.Encoder.MinQP;
                    document.getElementById('encoder-max-qp-text').value = settingsJSON.Encoder.MaxQP;
                    document.getElementById('encoder-filler-data-tgl').checked = settingsJSON.Encoder.FillerData == 1;
                    document.getElementById('encoder-multipass').value = settingsJSON.Encoder.MultiPass;
                    */
                }
                if (settingsJSON.WebRTC) {
                    /*
                    document.getElementById('webrtc-degradation-pref').value = settingsJSON.WebRTC.DegradationPref;
                    document.getElementById("webrtc-max-fps-text").value = settingsJSON.WebRTC.MaxFPS;
                    document.getElementById("webrtc-min-bitrate-text").value = settingsJSON.WebRTC.MinBitrate / 1000;
                    document.getElementById("webrtc-max-bitrate-text").value = settingsJSON.WebRTC.MaxBitrate / 1000;
                    document.getElementById("webrtc-low-qp-text").value = settingsJSON.WebRTC.LowQP;
                    document.getElementById("webrtc-high-qp-text").value = settingsJSON.WebRTC.HighQP;
                    */
                }
            } else {
                console.error(`unrecognized data received, packet ID ${view[0]}`);
            }
        };



        createWebRtcOffer();

        return webRtcPlayerObj.video;


    }


    const sendInputData = (data) => {

        if (webRtcPlayerObj) {
            resetAfkWarningTimer();
            webRtcPlayerObj.send(data);
        } else {
            let tmpWebRtcPlayerObj = window.__safeRtc;
            resetAfkWarningTimer();
            try {
                tmpWebRtcPlayerObj.send(data);
            } catch (e) {
                console.log(e);
            }

        }
    }



    const onWebRtcAnswer = (webRTCData) => {
        webRtcPlayerObj.receiveAnswer(webRTCData);

        let printInterval = 5 * 60 * 1000; /*Print every 5 minutes*/
        let nextPrintDuration = printInterval;

        webRtcPlayerObj.onAggregatedStats = (aggregatedStats) => {
            let numberFormat = new Intl.NumberFormat(window.navigator.language, {
                maximumFractionDigits: 0
            });
            let timeFormat = new Intl.NumberFormat(window.navigator.language, {
                maximumFractionDigits: 0,
                minimumIntegerDigits: 2
            });

            // Calculate duration of run
            let runTime = (aggregatedStats.timestamp - aggregatedStats.timestampStart) / 1000;
            let timeValues = [];
            let timeDurations = [60, 60];
            for (let timeIndex = 0; timeIndex < timeDurations.length; timeIndex++) {
                timeValues.push(runTime % timeDurations[timeIndex]);
                runTime = runTime / timeDurations[timeIndex];
            }
            timeValues.push(runTime);

            let runTimeSeconds = timeValues[0];
            let runTimeMinutes = Math.floor(timeValues[1]);
            let runTimeHours = Math.floor([timeValues[2]]);

            let receivedBytesMeasurement = 'B';
            let receivedBytes = aggregatedStats.hasOwnProperty('bytesReceived') ? aggregatedStats.bytesReceived : 0;
            let dataMeasurements = ['kB', 'MB', 'GB'];
            for (let index = 0; index < dataMeasurements.length; index++) {
                if (receivedBytes < 100 * 1000)
                    break;
                receivedBytes = receivedBytes / 1000;
                receivedBytesMeasurement = dataMeasurements[index];
            }

            let qualityStatus = document.getElementById("qualityStatus");

            // "blinks" quality status element for 1 sec by making it transparent, speed = number of blinks
            let blinkQualityStatus = function (speed) {
                let iter = speed;
                let opacity = 1; // [0..1]
                let tickId = setInterval(
                    function () {
                        opacity -= 0.1;
                        // map `opacity` to [-0.5..0.5] range, decrement by 0.2 per step and take `abs` to make it blink: 1 -> 0 -> 1
                        qualityStatus.style = `opacity: ${Math.abs((opacity - 0.5) * 2)}`;
                        if (opacity <= 0.1) {
                            if (--iter == 0) {
                                clearInterval(tickId);
                            } else { // next blink
                                opacity = 1;
                            }
                        }
                    },
                    100 / speed // msecs
                );
            };

            const orangeQP = 26;
            const redQP = 35;

            let statsText = '';
            

            let color = "lime";
            if (VideoEncoderQP > redQP) {
                color = "red";
                blinkQualityStatus(2);
                statsText += `<div style="color: ${color}">Bad network connection</div>`;
            } else if (VideoEncoderQP > orangeQP) {
                color = "orange";
                blinkQualityStatus(1);
                statsText += `<div style="color: ${color}">Spotty network connection</div>`;
            }

            try {
                qualityStatus.className = `${color}Status`;
            } catch (e) {

            }

            statsText += `<div>Duration: ${timeFormat.format(runTimeHours)}:${timeFormat.format(runTimeMinutes)}:${timeFormat.format(runTimeSeconds)}</div>`;
            statsText += `<div>Video Resolution: ${aggregatedStats.hasOwnProperty('frameWidth') && aggregatedStats.frameWidth && aggregatedStats.hasOwnProperty('frameHeight') && aggregatedStats.frameHeight ?
                    aggregatedStats.frameWidth + 'x' + aggregatedStats.frameHeight : 'Chrome only'
                }</div>`;
            statsText += `<div>Received (${receivedBytesMeasurement}): ${numberFormat.format(receivedBytes)}</div>`;
            statsText += `<div>Frames Decoded: ${aggregatedStats.hasOwnProperty('framesDecoded') ? numberFormat.format(aggregatedStats.framesDecoded) : 'Chrome only'}</div>`;
            statsText += `<div>Packets Lost: ${aggregatedStats.hasOwnProperty('packetsLost') ? numberFormat.format(aggregatedStats.packetsLost) : 'Chrome only'}</div>`;
            statsText += `<div style="color: ${color}">Bitrate (kbps): ${aggregatedStats.hasOwnProperty('bitrate') ? numberFormat.format(aggregatedStats.bitrate) : 'Chrome only'}</div>`;
            statsText += `<div>Framerate: ${aggregatedStats.hasOwnProperty('framerate') ? numberFormat.format(aggregatedStats.framerate) : 'Chrome only'}</div>`;
            statsText += `<div>Frames dropped: ${aggregatedStats.hasOwnProperty('framesDropped') ? numberFormat.format(aggregatedStats.framesDropped) : 'Chrome only'}</div>`;
            statsText += `<div>Net RTT (ms): ${aggregatedStats.hasOwnProperty('currentRoundTripTime') ? numberFormat.format(aggregatedStats.currentRoundTripTime * 1000) : 'Can\'t calculate'}</div>`;
            statsText += `<div>Browser receive to composite (ms): ${aggregatedStats.hasOwnProperty('receiveToCompositeMs') ? numberFormat.format(aggregatedStats.receiveToCompositeMs) : 'Chrome only'}</div>`;
            statsText += `<div style="color: ${color}">Video Quantization Parameter: ${VideoEncoderQP}</div>`;

            let statInfo = {
                Quality : VideoEncoderQP,
                Duration: `${timeFormat.format(runTimeHours)}:${timeFormat.format(runTimeMinutes)}:${timeFormat.format(runTimeSeconds)}`,
                Resolution: `${aggregatedStats.hasOwnProperty('frameWidth') && aggregatedStats.frameWidth && aggregatedStats.hasOwnProperty('frameHeight') && aggregatedStats.frameHeight ? aggregatedStats.frameWidth + 'x' + aggregatedStats.frameHeight : 'Chrome only'}`,
                PacketLost: `${aggregatedStats.hasOwnProperty('packetsLost') ? numberFormat.format(aggregatedStats.packetsLost) : 'Chrome only'}`,
                Bitrate: `${aggregatedStats.hasOwnProperty('bitrate') ? numberFormat.format(aggregatedStats.bitrate) : 'Chrome only'}`,
                Framerate: `${aggregatedStats.hasOwnProperty('framerate') ? numberFormat.format(aggregatedStats.framerate) : 'Chrome only'}`
            }

            //let statsDiv = document.getElementById("stats");
            // statsDiv.innerHTML = statsText;
            for (let listener of streamingDataListeners.values()) { 
                listener(statInfo);
            }


            if (print_stats) {
                if (aggregatedStats.timestampStart) {
                    if ((aggregatedStats.timestamp - aggregatedStats.timestampStart) > nextPrintDuration) {
                        if (ws && ws.readyState === WS_OPEN_STATE) {
                            console.log(`-> SS: stats\n${JSON.stringify(aggregatedStats)}`);
                            ws.send(JSON.stringify({
                                type: 'stats',
                                data: aggregatedStats
                            }));
                        }
                        nextPrintDuration += printInterval;
                    }
                }
            }
        };

        webRtcPlayerObj.aggregateStats(1 * 1000 /*Check every 1 second*/);

        webRtcPlayerObj.latencyTestTimings.OnAllLatencyTimingsReady = function (timings) {

            if (!timings.BrowserReceiptTimeMs) {
                return;
            }

            let latencyExcludingDecode = timings.BrowserReceiptTimeMs - timings.TestStartTimeMs;
            let uePixelStreamLatency = timings.UEPreEncodeTimeMs == 0 || timings.UEPreCaptureTimeMs == 0 ? "???" : timings.UEPostEncodeTimeMs - timings.UEPreCaptureTimeMs;
            let captureLatency = timings.UEPostCaptureTimeMs - timings.UEPreCaptureTimeMs;
            let encodeLatency = timings.UEPostEncodeTimeMs - timings.UEPreEncodeTimeMs;
            let ueLatency = timings.UETransmissionTimeMs - timings.UEReceiptTimeMs;
            let networkLatency = latencyExcludingDecode - ueLatency;
            let browserSendLatency = latencyExcludingDecode - networkLatency - ueLatency;

            //these ones depend on FrameDisplayDeltaTimeMs
            let endToEndLatency = null;
            let browserSideLatency = null;

            if (timings.FrameDisplayDeltaTimeMs && timings.BrowserReceiptTimeMs) {
                endToEndLatency = timings.FrameDisplayDeltaTimeMs + latencyExcludingDecode;
                browserSideLatency = endToEndLatency - networkLatency - ueLatency;
            }

            let latencyStatsInnerHTML = '';
            latencyStatsInnerHTML += `<div>Net latency RTT (ms): ${networkLatency}</div>`;
            latencyStatsInnerHTML += `<div>UE Capture+Encode (ms): ${uePixelStreamLatency}</div>`;
            latencyStatsInnerHTML += `<div>UE Capture (ms): ${captureLatency}</div>`;
            latencyStatsInnerHTML += `<div>UE Encode (ms): ${encodeLatency}</div>`;
            latencyStatsInnerHTML += `<div>Total UE latency (ms): ${ueLatency}</div>`;
            latencyStatsInnerHTML += `<div>Browser send latency (ms): ${browserSendLatency}</div>`
            latencyStatsInnerHTML += timings.FrameDisplayDeltaTimeMs && timings.BrowserReceiptTimeMs ? `<div>Browser receive latency (ms): ${timings.FrameDisplayDeltaTimeMs}</div>` : "";
            latencyStatsInnerHTML += browserSideLatency ? `<div>Total browser latency (ms): ${browserSideLatency}</div>` : "";
            latencyStatsInnerHTML += `<div>Total latency (excluding browser) (ms): ${latencyExcludingDecode}</div>`;
            latencyStatsInnerHTML += endToEndLatency ? `<div>Total latency (ms): ${endToEndLatency}</div>` : "";
            //document.getElementById("LatencyStats").innerHTML = latencyStatsInnerHTML;
        }
    }





    const createWebRtcOffer = () => {
        if (webRtcPlayerObj) {
            console.log('Creating offer');
            webRtcPlayerObj.createOffer();
        } else {
            console.log('WebRTC player not setup, cannot create offer');
        }
    }




    const onConfig = (confirm) => {
        let playerDiv = document.getElementById('player');
        setupWebRtcPlayer(playerDiv, confirm);

    }

    const onWebRtcIce = async (iceCandidate) => {
        if (webRtcPlayerObj)
            webRtcPlayerObj.handleCandidateFromServer(iceCandidate);
    }


    const connect = () => {
        "use strict";

        window.WebSocket = window.WebSocket || window.MozWebSocket;

        if (!window.WebSocket) {
            alert('Your browser doesn\'t support WebSocket');
            return;
        }

        // ws = new WebSocket(window.location.href.replace('http://', 'ws://').replace('https://', 'wss://'));
        let config = getConfig();
        let pixel_streaming_server = config.pixelstreamingUrl;
        console.log(pixel_streaming_server);

        console.log("PX:", pixel_streaming_server);
        ws = new WebSocket(pixel_streaming_server);

        ws.onmessage = function (event) {
            console.log(`<- SS: ${event.data}`);
            let msg = JSON.parse(event.data);
            if (msg.type === 'config') {
                onConfig(msg);
            } else if (msg.type === 'playerCount') {
                //updateKickButton(msg.count - 1);
                
            } else if (msg.type === 'answer') {
                onWebRtcAnswer(msg);
            } else if (msg.type === 'iceCandidate') {
                onWebRtcIce(msg.candidate);
            } else {
                console.log(`invalid SS message type: ${msg.type}`);
            }
        };

        ws.onerror = function (event) {
            console.log(`WS error: ${JSON.stringify(event)}`);
        };

        ws.onclose = function (event) {
            console.log(`WS closed: ${JSON.stringify(event.code)} - ${event.reason}`);
            ws = undefined;
            is_reconnection = true;

            // destroy `webRtcPlayerObj` if any
            let playerDiv = document.getElementById('player');
            if (webRtcPlayerObj) {
                playerDiv.removeChild(webRtcPlayerObj.video);
                webRtcPlayerObj.close();
                webRtcPlayerObj = undefined;
            }

            let reclickToStart = setTimeout(connect, 4000);
        };
    }




    return (
        <MetaHumanContext.Provider
            value={{
                actor,
                background,
                voice,
                toUE,
                initialize,
                addResponseEventListener,
                addStreamingDataListeners,
                isInitialized,
                isTalking,
                setResolution,
                smallVideoBox
            }}
        >
            {children}
        </MetaHumanContext.Provider>
    );

};


export const useMetaHuman = () => {
    const context = useContext(MetaHumanContext);
    if (!context) {
        throw new Error("useMetaHuman must be used within a MetaHumanProvider");
    }
    return context;
};


